import React from 'react'
import styled from 'styled-components'

const Tab = styled.div`
    text-transform: uppercase;
    border-bottom: 2px solid ${props => props.active ? '#415dd4' : 'transparent'};
    transition: border-color .3s cubic-bezier(.55, 0, .1, 1);
    color: ${props => props.active ? '#415dd4' : '#a9b9bd'};
    cursor: pointer;
    padding: 10px;
    width: 50%;
    text-align: center;
    font-size: 12px;
    letter-spacing: 1px;
`

export default ({children, active, onClick}) => (
    <Tab active={active} onClick={onClick}>
        {children}
    </Tab>
)
